"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.StyledInput = exports.Root = exports.classes = void 0;
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const styles_1 = require("@mui/material/styles");
const PREFIX = "RadioButton";
exports.classes = {
    disabled: `${PREFIX}-disabled`,
    label: `${PREFIX}-label`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "inline-block",
    color: theme.colours.inter,
    [`&.${exports.classes.disabled}`]: {
        opacity: 0.38,
        color: theme.colours.black
    },
    [`.${exports.classes.label}`]: {
        display: "flex",
        flexFlow: "row nowrap",
        cursor: "pointer",
        border: `1px solid ${theme.colours.storm}`,
        borderRadius: "6px",
        overflow: "hidden"
    }
}));
exports.StyledInput = (0, styles_1.styled)("input")({
    position: "absolute",
    clipPath: "inset(100%)",
    [`&:focus + .${exports.classes.label}`]: {
        border: "1px solid currentColor"
    },
    [`&:checked + .${exports.classes.label}`]: {
        border: "2px solid currentColor"
    }
});
exports.StyledButton = (0, styles_1.styled)(ButtonBase_1.default)({
    padding: "12px 48px",
    color: "currentColor",
    fontSize: "18px",
    lineHeight: "24px"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3JhZGlvLWJ1dHRvbi9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsMEVBQWtEO0FBQ2xELGlEQUE4QztBQUU5QyxNQUFNLE1BQU0sR0FBRyxhQUFhLENBQUM7QUFFaEIsUUFBQSxPQUFPLEdBQUc7SUFDckIsUUFBUSxFQUFFLEdBQUcsTUFBTSxXQUFXO0lBQzlCLEtBQUssRUFBRSxHQUFHLE1BQU0sUUFBUTtDQUN6QixDQUFDO0FBRVcsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2hELE9BQU8sRUFBRSxjQUFjO0lBQ3ZCLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7SUFDMUIsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxRQUFRLEVBQUUsQ0FBQyxFQUFFO1FBQ3pCLE9BQU8sRUFBRSxJQUFJO1FBQ2IsS0FBSyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztLQUMzQjtJQUNELENBQUMsSUFBSSxlQUFPLENBQUMsS0FBSyxFQUFFLENBQUMsRUFBRTtRQUNyQixPQUFPLEVBQUUsTUFBTTtRQUNmLFFBQVEsRUFBRSxZQUFZO1FBQ3RCLE1BQU0sRUFBRSxTQUFTO1FBQ2pCLE1BQU0sRUFBRSxhQUFhLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFO1FBQzFDLFlBQVksRUFBRSxLQUFLO1FBQ25CLFFBQVEsRUFBRSxRQUFRO0tBQ25CO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLFdBQVcsR0FBRyxJQUFBLGVBQU0sRUFBQyxPQUFPLENBQUMsQ0FBQztJQUN6QyxRQUFRLEVBQUUsVUFBVTtJQUNwQixRQUFRLEVBQUUsYUFBYTtJQUN2QixDQUFDLGNBQWMsZUFBTyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDL0IsTUFBTSxFQUFFLHdCQUF3QjtLQUNqQztJQUNELENBQUMsZ0JBQWdCLGVBQU8sQ0FBQyxLQUFLLEVBQUUsQ0FBQyxFQUFFO1FBQ2pDLE1BQU0sRUFBRSx3QkFBd0I7S0FDakM7Q0FDRixDQUFDLENBQUM7QUFFVSxRQUFBLFlBQVksR0FBRyxJQUFBLGVBQU0sRUFBQyxvQkFBVSxDQUFDLENBQUM7SUFDN0MsT0FBTyxFQUFFLFdBQVc7SUFDcEIsS0FBSyxFQUFFLGNBQWM7SUFDckIsUUFBUSxFQUFFLE1BQU07SUFDaEIsVUFBVSxFQUFFLE1BQU07Q0FDbkIsQ0FBQyxDQUFDIn0=